import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';

const residentialIndicatorMapper = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  const value = appliedFilter.criterionArgumentValue;
  return {
    normalizableCollectionFilters: [
      {
        column: 'ResidentialIndicator',
        values: [value],
        isIn: criteria.isIn,
        isNull: criteria.isNull,
      },
    ],
  };
};

export default residentialIndicatorMapper;
